// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__GRF41","insightsList":"newBusinessInsightsMenu_insightsList__3UNBv","active":"newBusinessInsightsMenu_active__3JvET"};